import { render, staticRenderFns } from "./CouponWindow.vue?vue&type=template&id=35e3f9cf&scoped=true&"
import script from "./CouponWindow.vue?vue&type=script&lang=js&"
export * from "./CouponWindow.vue?vue&type=script&lang=js&"
import style0 from "./CouponWindow.vue?vue&type=style&index=0&id=35e3f9cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3f9cf",
  null
  
)

export default component.exports